import axiosInstance from './apiClient'
import { Advisor } from '@/redux/types/advisor'
import { getErrorMessage } from '@/lib/utils'

export const fetchAdvisors = (roomId: string, playerId?: string) => {
  return axiosInstance.get<Advisor[]>(`/oge/chatbot/advisors/`, {
    params: { roomId, playerId },
  })
}

export const createAdvisor = (advisorData: string) => {
  return axiosInstance.post('/oge/chatbot/create-advisor/', {
    chatbotname: advisorData,
  })
}

export const addAdvisorsToRoom = (roomId: string, advisorIds: string[]) => {
  return axiosInstance.post('/oge/add-advisors/', {
    room_id: roomId,
    advisor_ids: advisorIds,
  })
}

export const initiateAdvisorExportAPI = async (
  chatbotId: string,
  withAssignments = true
): Promise<{ export_token: string; message: string }> => {
  try {
    const response = await axiosInstance.post(
      `/oge/chatbot/advisors/${chatbotId}/export/`,
      { with_assignments: withAssignments }
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
